import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, FIELD } from "@/lib/api";
import { Field } from "@/components/common/Field";
import { Input } from "@/components/ui/input";

export const ServiceFees = () => {
  const [fees, setFees] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/service-fees").then((r) => setFees(r.data)); }, []);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.put("/admin/service-fees", { fees: Object.fromEntries(Object.entries(fees).map(([k, v]) => [k, Number(v) || 0])) });
      setFees(data);
      toast.success("Consultation prices saved");
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  if (!fees) return <p className="text-white/50">Loading…</p>;
  return (
    <form onSubmit={save} className="border border-white/10 p-6 md:p-8 max-w-2xl space-y-6" data-testid="service-fees-form">
      <p className="text-sm text-white/60">Set the consultation fee clients pay online when booking each service. Leave at <span className="text-[#D4AF37]">0</span> for free consultations. Academy class prices are set per class in Manage Events.</p>
      {Object.keys(fees).map((s, i) => (
        <Field key={s} label={s}>
          <div className="relative max-w-xs">
            <span className="absolute left-4 top-1/2 -translate-y-1/2 text-white/50">$</span>
            <Input className={`${FIELD} pl-8`} type="number" min={0} step="0.01" value={fees[s]} onChange={(e) => setFees({ ...fees, [s]: e.target.value })} data-testid={`service-fee-input-${i}`} />
          </div>
        </Field>
      ))}
      <button className="btn-gold !py-3" disabled={busy} data-testid="service-fees-save-button">{busy ? "Saving…" : "Save Prices"}</button>
    </form>
  );
};
